import React from 'react';
import {Col, Container, Row} from "react-bootstrap";

const Perks = () => {
  return (
    <div className="Perks p-100">
        <Container className="h-100">
                <Row className="h-100">
                    <Col xs={12} md={10} lg={10} xl={10} xxl={10} className="m-auto text-center">
                        <h2>Perks Of Working With A Top-Grade Enterprise App Development Company</h2>
                        <p>Choosing a top-grade enterprise app development company comes with several advantages for your business.</p>
                    </Col>
                </Row>
                <Row className="h-100 perks-padd">
                <Col xs={12} md={6} lg={6} xl={3} xxl={3} className="mb-lg-5 mb-xl-0">
                    <div className="perks-box">
                        <div className="perks-content">
                            <h4>Expertise You Can Trust</h4>
                            <p>Benefit from the experience and knowledge of seasoned professionals who understand the ins and outs of enterprise app development.</p>
                        </div>
                    </div>
                </Col>
                 <Col xs={12} md={6} lg={6} xl={3} xxl={3} className="mb-lg-5 mb-xl-0">
                 <div className="perks-box">
                        <div className="perks-content">
                            <h4>Scalability and Flexibility Options</h4>
                            <p>Scale up your enterprise application based on the increasing requirements with our flexible development approach.</p>
                        </div>
                    </div>
                </Col>
                 <Col xs={12} md={6} lg={6} xl={3} xxl={3}>
                 <div className="perks-box">
                        <div className="perks-content">
                            <h4>Absolute Process Transparency</h4>
                            <p>Stay consistently informed about the ongoing procedures by utilizing our project management tools, taking into account all relevant insights.</p>
                        </div>
                    </div>
                </Col>
                 <Col xs={12} md={6} lg={6} xl={3} xxl={3}>
                 <div className="perks-box">
                        <div className="perks-content">
                            <h4>Cost-Effective Pricing Models</h4>
                            <p>Get the right estimate for your project from our app cost calculator formulated with cost-effective pricing models.</p>
                        </div>
                    </div>
                </Col>
                </Row>
            </Container>
    </div>
  )
}

export default Perks